<article class="row" [ngClass]="rowSpacing">
  <div [ngClass]="columnSpacing">
    <div
      sc-placeholder
      name="column-left"
      class="content-item"
      [ngClass]="contentOptionsLeft"
      [rendering]="rendering"
    ></div>
  </div>
  <div [ngClass]="columnSpacing">
    <div
      sc-placeholder
      name="column-center-left"
      class="content-item"
      [ngClass]="contentOptionsCenterLeft"
      [rendering]="rendering"
    ></div>
  </div>
  <div [ngClass]="columnSpacing">
    <div
      sc-placeholder
      name="column-center-right"
      class="content-item"
      [ngClass]="contentOptionsCenterRight"
      [rendering]="rendering"
    ></div>
  </div>
  <div [ngClass]="columnSpacing">
    <div
      sc-placeholder
      name="column-right"
      class="content-item"
      [ngClass]="contentOptionsRight"
      [rendering]="rendering"
    ></div>
  </div>
</article>
